var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "core-js/modules/es6.function.name", "react", "prop-types"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("core-js/modules/es6.function.name"), require("react"), require("prop-types"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.objectWithoutProperties, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.es6Function, global.react, global.propTypes);
    global.withAutoSliding = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _objectWithoutProperties2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _es6Function, _react, _propTypes) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var getDisplayName = function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  };

  var flash = function flash(action) {
    return global.sessionStorage ? action(global.sessionStorage) : false;
  };

  var withAutoSliding = function withAutoSliding(WrappedComponent) {
    var WithAutoSliding = /*#__PURE__*/function (_PureComponent) {
      (0, _inherits2.default)(WithAutoSliding, _PureComponent);

      var _super = _createSuper(WithAutoSliding);

      function WithAutoSliding(props) {
        var _this;

        (0, _classCallCheck2.default)(this, WithAutoSliding);
        _this = _super.call(this, props);
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchStart", function (_ref) {
          var touches = _ref.touches;
          _this.touchStartX = touches[0].pageX;
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTouchEnd", function (event, callback) {
          var direction = event.changedTouches[0].pageX - _this.touchStartX;

          if (Math.abs(direction) < 30) {
            return;
          }

          if (direction < 0) {
            _this.nextSlide(callback);
          } else {
            _this.prevSlide(callback);
          }

          _this.stopAutoplay();
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletClick", function (slideIndex, teaser) {
          _this.setState({
            mouseFocus: true,
            slideIndex: slideIndex
          }, function () {
            teaser.focus();
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletNavigate", function () {
          _this.setState({
            mouseFocus: false
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletPress", function (slideIndex, teaser) {
          _this.setState({
            mouseFocus: false,
            slideIndex: slideIndex
          }, function () {
            teaser.focus();
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "togglePlayButton", function () {
          if (_this.state.autoplay) {
            _this.stopAutoplay();

            flash(function (flashMemory) {
              return flashMemory.setItem('ASGNoAutoplay', true);
            });
          } else {
            _this.startAutoplay();

            flash(function (flashMemory) {
              return flashMemory.removeItem('ASGNoAutoplay');
            });
          }
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prevSlide", function () {
          var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var teasers = _this.props.teasers;

          _this.setState(function (_ref2) {
            var slideIndex = _ref2.slideIndex;
            return {
              slideIndex: slideIndex - 1 < 0 ? teasers.length - 1 : slideIndex - 1
            };
          }, function () {
            if (callback) {
              callback(_this.state.slideIndex);
            }
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "nextSlide", function () {
          var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          var teasers = _this.props.teasers;

          _this.setState(function (_ref3) {
            var slideIndex = _ref3.slideIndex;
            return {
              slideIndex: slideIndex + 1 === teasers.length ? 0 : slideIndex + 1
            };
          }, function () {
            if (callback) {
              callback(_this.state.slideIndex);
            }
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pauseAutoplay", function () {
          _this.setState({
            pausing: true
          });
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "unpauseAutoplay", function () {
          _this.setState({
            pausing: false
          });

          if (_this.state.autoplay) {
            _this.startAutoplay(false);
          }
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stopAutoplay", function () {
          var updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          clearInterval(_this.autoplayInterval);
          _this.autoplayInterval = null;

          if (updateState) {
            _this.setState({
              autoplay: false
            });
          }
        });
        (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "startAutoplay", function () {
          var updateState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          var autoplaySpeed = _this.props.autoplaySpeed;

          _this.stopAutoplay(updateState);

          _this.autoplayInterval = setInterval(function () {
            if (!_this.state.pausing) {
              // Do not sliding next if paused
              _this.nextSlide();
            }
          }, autoplaySpeed);

          if (updateState) {
            _this.setState({
              autoplay: true
            });
          }
        });
        _this.autoplayInterval = null;
        _this.touchStartX = 0;
        _this.state = {
          autoplay: true,
          mouseFocus: true,
          pausing: false,
          slideIndex: 0
        };
        return _this;
      }

      (0, _createClass2.default)(WithAutoSliding, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          if (flash(function (flashMemory) {
            return flashMemory.getItem('ASGNoAutoplay');
          })) {
            this.stopAutoplay();
          } else {
            this.startAutoplay(false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.stopAutoplay();
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              autoplaySpeed = _this$props.autoplaySpeed,
              passThroughProps = (0, _objectWithoutProperties2.default)(_this$props, ["autoplaySpeed"]);
          var injectedProp = {
            autoplay: this.state.autoplay,
            mouseFocus: this.state.mouseFocus,
            onBulletClick: this.onBulletClick,
            onBulletNavigate: this.onBulletNavigate,
            onBulletPress: this.onBulletPress,
            pauseAutoplay: this.pauseAutoplay,
            slideIndex: this.state.slideIndex,
            togglePlayButton: this.togglePlayButton,
            touchEnd: this.onTouchEnd,
            touchStart: this.onTouchStart,
            unpauseAutoplay: this.unpauseAutoplay
          };
          return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
            injectedProp: injectedProp
          }, passThroughProps));
        }
      }]);
      return WithAutoSliding;
    }(_react.PureComponent);

    (0, _defineProperty2.default)(WithAutoSliding, "propTypes", {
      autoplaySpeed: _propTypes.default.number,
      labels: _propTypes.default.shape({
        active: _propTypes.default.string,
        display: _propTypes.default.string,
        mainSliderLabel: _propTypes.default.string,
        pause: _propTypes.default.string,
        play: _propTypes.default.string
      }).isRequired,
      showDate: _propTypes.default.bool,
      teasers: _propTypes.default.arrayOf(_propTypes.default.shape()),
      theme: _propTypes.default.string,
      trackingEnabled: _propTypes.default.bool
    });
    (0, _defineProperty2.default)(WithAutoSliding, "defaultProps", {
      autoplaySpeed: 6000,
      labels: {
        active: 'lien actif',
        display: 'Afficher',
        mainSliderLabel: 'Les programmes à la une',
        pause: 'Mettre en pause le défilement des programmes à la une',
        play: 'Activer le défilement des programmes à la une'
      },
      showDate: false,
      teasers: [],
      theme: 'next',
      trackingEnabled: false
    });
    WithAutoSliding.displayName = "WithAutoSliding(".concat(getDisplayName(WrappedComponent), ")");
    return WithAutoSliding;
  };

  var _default = withAutoSliding;
  _exports.default = _default;
});